import "./menu.css";
import React from "react";
import { Navbar } from "react-bootstrap";
import { useIsPublicPage } from "../../lib/routing";
import { ReactComponent as Logo } from "../../pages/login/images/logo.svg";
import mountains from "./images/mountains.png";
import { DesktopHeader } from "./tree/DesktopDropdowns";
import { MobileHeader } from "./MobileHeader";
import ErrorBoundary from "lib/ErrorBoundary";
import { history } from "redux/configureStore";
import { _t } from "app/i18n/i18n";
import { useLocation } from "react-router";
import { ContentCompanyLogo } from "./ContentCompanyLogo";

export const HeaderAlt = () => {
  const isPublic = useIsPublicPage();
  const { pathname, search } = useLocation();
  if (isPublic || search.includes("hideHeader")) return null;

  const goHome = () => history.push("/latest-research");

  return (
    <ErrorBoundary>
      <Navbar key={pathname} bg="primary" variant="dark" expand="md" className="desktop-menu p-md-0 flex-nowrap mb-3">
        <Navbar.Brand
          href="#"
          title={_t("Latest Research")}
          onClick={goHome}
          className="p-0 d-none d-lg-block bg-white"
        >
          <NomuraLogo />
          <img src={mountains} alt="mish" />
        </Navbar.Brand>

        <MobileHeader />
        <DesktopHeader />
        <ContentCompanyLogo />
      </Navbar>
    </ErrorBoundary>
  );
};

export const NomuraLogo = () => (
  <Logo className="header-logo d-inline bg-white fill-red ml-2" style={{ width: 150, height: 50 }} />
);
